module.exports = __webpack_public_path__ + "static/media/Colette Ray Queen Headboard - 155 cm_Beige.3560da12.png";